const initState = () => {
  return {
    showAuthTokenModal: false,
    showMsgModal: false,
    msgBody: ''
  };
}

const messageCenter = (state=initState(), action) => {
  switch (action.type) {

    case 'CLOSE_MSG_MODAL':
      return {...state, ...{showMsgModal: false, msgBody: ""}}

    case 'OPEN_MSG_MODAL':
      return {...state, ...{showMsgModal: true, msgBody: action.payload}}

    case 'TOGGLE_AUTH_TOKEN_MODAL':
      return {...state, ...{showAuthTokenModal: !state.showAuthTokenModal}}

    default:
      return state;
  }
}

export default messageCenter;
